import { NavLink, useLocation } from 'react-router-dom';
import { TabsTrigger } from '@optiaxiom/react';

type TabLinkProps = {
  path: string;
  value: string;
  children: React.ReactNode;
  isActive?: (pathname: string, value: string) => boolean;
  exactMatch?: boolean;
};

export const TabLink = ({ path, value, children, isActive, exactMatch = false }: TabLinkProps) => {
  const location = useLocation();

  const getActiveState = () => {
    if (isActive) {
      return isActive(location.pathname, value);
    }

    if (exactMatch) {
      return location.pathname === path || location.pathname === `${path}/`;
    }

    return location.pathname.includes(path);
  };

  return (
    <NavLink to={path} style={{ textDecoration: 'none', color: 'inherit' }}>
      <TabsTrigger value={value} data-state={getActiveState() ? 'active' : 'inactive'}>
        {children}
      </TabsTrigger>
    </NavLink>
  );
};
